import useBedbankOfferSearchPricing from 'hooks/useBedbankOfferSearchPricing'
import React, { useMemo } from 'react'
import CellContent from './CellContent'
import LoyaltyPointsEarn from 'loyalty/components/Earn/LoyaltyPointsEarn'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import Group from 'components/utils/Group'
import { getLoyaltyBedbankPackageId } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters: App.OfferListFilters
  priceTotals?: {
    price: number
    memberPrice: number
    value: number
  }
}

function BedbankHotelSearchPointsCell({ offer, filters, priceTotals }: Props) {
  const {
    offerPrice,
    offerMemberPrice,
    mx,
    propertyFees,
    shownRate,
  } = useBedbankOfferSearchPricing(offer, filters)
  const isLoyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)
  const pointsEarnCalculationRequests = useMemo<Array<App.LoyaltyPointsEarnCalculationRequest | undefined>>(() => {
    return [
      {
        price: priceTotals ? priceTotals.price : offerPrice - propertyFees,
        memberPrice: priceTotals ? priceTotals.memberPrice : offerMemberPrice > 0 ? offerMemberPrice - propertyFees : 0,
        mx,
        loyaltyProductType: 'hotel_lpp_eps',
        packageId: getLoyaltyBedbankPackageId(offer.property.id, shownRate?.supplierCode),
        offerId: offer.id,
      },
    ]
  }, [offerPrice, offerMemberPrice, mx, propertyFees, priceTotals, offer, shownRate])

  if (!isLoyaltyEnabled) {
    return null
  }

  return <CellContent>
    <Group direction="vertical" verticalAlign="center" fullHeight>
      <LoyaltyPointsEarn calculationRequests={pointsEarnCalculationRequests} calculationType="estimate" />
    </Group>
  </CellContent>
}

export default BedbankHotelSearchPointsCell
